import { render, staticRenderFns } from "./translateSelect.vue?vue&type=template&id=2640776d"
import script from "./translateSelect.vue?vue&type=script&lang=js"
export * from "./translateSelect.vue?vue&type=script&lang=js"
import style0 from "./translateSelect.vue?vue&type=style&index=0&id=2640776d&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2640776d')) {
      api.createRecord('2640776d', component.options)
    } else {
      api.reload('2640776d', component.options)
    }
    module.hot.accept("./translateSelect.vue?vue&type=template&id=2640776d", function () {
      api.rerender('2640776d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/translateSelect.vue"
export default component.exports